export default "__VITE_ASSET__CFZpPAKD__"